import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sales-trends-graph',
  templateUrl: './sales-trends-graph.component.html',
  styleUrls: ['./sales-trends-graph.component.scss']
})
export class SalesTrendsGraphComponent implements OnInit,OnDestroy {
  @Input() chartDataSet;
  @Input() id;
  private destroy$ = new Subject<void>();
  public chartColors: any[] = [
    {
      backgroundColor: ["#ED6567", "#4972F3","#EDC92D","#44D526"],
    },
  ];
  doughnutChartColors: any[] = ["#ED6567", "#4972F3","#EDC92D","#44D526"];
  data: any = [] = [];
  salesTrendsChartData: any[]=[];

  constructor() { }

  ngOnInit(): void {
   this.salesTrendsChartData = [['Fees',Math.abs(this.chartDataSet.salesFees) || 0],['PPC',Math.abs(this.chartDataSet.ppcSpent) || 0],
   ['Profit',Math.abs(this.chartDataSet.profit) || 0],['COGS',Math.abs(this.chartDataSet.salesCogs) || 0]];
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
